<template>
  <div>
    <div class="card p-4 shadow-sm">
      <h3 class="mb-3">Grupos de complementos para platillos</h3>

      <!-- Buscador -->
      <div class="mb-3">
        <input
          type="text"
          class="form-control"
          placeholder="Buscar grupo por nombre"
          v-model="busqueda"
          @input="buscarGrupo"
        />
      </div>

      <!-- Botón agregar -->
      <div class="d-flex justify-content-end mb-3">
        <button class="btn btn-success" @click="mostrarFormulario = true">
          + Agregar Grupo
        </button>
      </div>

      <!-- Toast -->
      <div
        v-if="mostrarToast"
        class="toast-container position-fixed top-0 end-0 p-3"
        style="z-index: 1055"
      >
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Formulario crear -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nuevo Grupo</h5>
     <div class="row g-3">
  <div class="col-md-4">
    <label class="form-label">Nombre del Grupo</label>
    <input v-model="nuevoGrupo.NombreGrupo" type="text" class="form-control" />
  </div>
  <div class="col-md-2">
    <label class="form-label">Mín Selecciones</label>
    <input v-model.number="nuevoGrupo.MinSelecciones" type="number" min="0" class="form-control" />
  </div>
  <div class="col-md-2">
    <label class="form-label">Máx Selecciones</label>
    <input v-model.number="nuevoGrupo.MaxSelecciones" type="number" min="1" class="form-control" />
  </div>
  <div class="col-md-2">
    <label class="form-label">Incluidas</label>
    <input v-model.number="nuevoGrupo.Incluidas" type="number" min="0" class="form-control" />
  </div>
  <div class="col-md-2">
    <label class="form-label">Área Producción</label>
    <select v-model.number="nuevoGrupo.AreaProduccion" class="form-select">
      <option :value="1">Cocina</option>
      <option :value="2">Barra</option>
    </select>
  </div>
</div>


       <!-- Items -->
<h6 class="mt-3">Opciones</h6>
<div v-for="(item, index) in nuevoGrupo.items" :key="index" class="row g-3 mb-2">
  <div class="col-md-6">
    <label class="form-label">Opción</label>
    <SearchableSelect
      v-model="item.IdOpcion"
      :items="opciones"
      item-value="IdOpcion"
      item-label="Nombre"
      placeholder="Buscar opción..."
      :show-selected="false"
    />
  </div>
  <div class="col-md-4">
    <label class="form-label">Precio Extra</label>
    <input
      v-model.number="item.PrecioExtra"
      type="number"
      min="0"
      class="form-control"
      placeholder="Precio extra"
    />
  </div>
  <div class="col-md-2 d-flex align-items-end">
    <button class="btn btn-danger btn-sm" @click="eliminarItem(index)">X</button>
  </div>
</div>
<button class="btn btn-secondary btn-sm mt-2" @click="agregarItem">+ Agregar Opción</button>


        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarGrupo">Guardar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Nombre</th>
              <th>Reglas</th>
              <th>Área Producción</th>
              <th>Opciones</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="grupos.length === 0">
              <td colspan="4">No hay grupos registrados.</td>
            </tr>
            <tr v-for="grp in grupos" :key="grp.IdGrupoOpcion">
              <td>{{ grp.NombreGrupo }}</td>
              <td>
                Mín: {{ grp.MinSelecciones }} / Máx: {{ grp.MaxSelecciones }} / Incluidas: {{ grp.Incluidas }}
              </td>
              <td>{{ grp.AreaProduccionNombre }}</td>
              <td>
                <ul class="list-unstyled">
                  <li v-for="item in grp.items" :key="item.IdGrupoOpcionItem">
                    {{ item.opcion?.Nombre || "Opción eliminada" }}
                    <span v-if="item.PrecioExtra > 0"> - Extra: Q{{ Number(item.PrecioExtra).toFixed(2) }}</span>
                  </li>
                </ul>
              </td>
              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModal(grp)">Editar</button>
                <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(grp)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Editar -->
<div v-if="mostrarModal" class="modal-backdrop " @click.self="cerrarModal">
  <div class="modal-content overflow-scroll max-h-[500px]" @click.stop>
    <div class="modal-header">
      <h5 class="modal-title">Editar Grupo</h5>
      <button type="button" class="btn-close" @click="cerrarModal"></button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <label class="form-label">Nombre del Grupo</label>
        <input v-model="grupoEditar.NombreGrupo" type="text" class="form-control" />
      </div>
      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label">Mín Selecciones</label>
          <input v-model.number="grupoEditar.MinSelecciones" type="number" min="0" class="form-control" />
        </div>
        <div class="col-md-4">
          <label class="form-label">Máx Selecciones</label>
          <input v-model.number="grupoEditar.MaxSelecciones" type="number" min="1" class="form-control" />
        </div>
        <div class="col-md-4">
          <label class="form-label">Incluidas</label>
          <input v-model.number="grupoEditar.Incluidas" type="number" min="0" class="form-control" />
        </div>
        <div class="col-md-3">
    <label class="form-label">Área Producción</label>
    <select v-model.number="grupoEditar.AreaProduccion" class="form-select">
      <option :value="1">Cocina</option>
      <option :value="2">Barra</option>
    </select>
  </div>
      </div>

      <h6 class="mt-3">Opciones</h6>
      <div v-for="(item, index) in grupoEditar.items" :key="index" class="row g-3 mb-2">
        <div class="col-md-6">
          <label class="form-label">Opción</label>
          <SearchableSelect
            v-model="item.IdOpcion"
            :items="opciones"
            item-value="IdOpcion"
            item-label="Nombre"
            placeholder="Buscar opción..."
            :show-selected="false"
          />
        </div>
        <div class="col-md-4">
          <label class="form-label">Precio Extra</label>
          <input v-model.number="item.PrecioExtra" type="number" min="0" class="form-control" />
        </div>
        <div class="col-md-2 d-flex align-items-end">
          <button class="btn btn-danger btn-sm" @click="grupoEditar.items.splice(index,1)">X</button>
        </div>
      </div>
      <button
        class="btn btn-secondary btn-sm mt-2"
        @click="grupoEditar.items.push({ IdOpcion: '', PrecioExtra: 0 })"
      >
        + Agregar Opción
      </button>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary me-2" @click="cerrarModal">Cancelar</button>
      <button class="btn btn-primary" @click="actualizarGrupo">Actualizar</button>
    </div>
  </div>
</div>


      <!-- Modal Eliminar -->
      <div v-if="mostrarModalEliminar" class="modal-backdrop" @click.self="cerrarModalEliminar">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
            <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
          </div>
          <div class="modal-body">
            <p>¿Eliminar el grupo <strong>{{ grupoEliminar?.NombreGrupo }}</strong>?</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary me-2" @click="cerrarModalEliminar">Cancelar</button>
            <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";
import SearchableSelect from "@/components/shared/SearchableSelect.vue";

export default {
  components: {
    SearchableSelect
  },
  name: "GruposOpciones",
  data() {
    return {
      grupos: [],
      opciones: [],
      copiaLista: [],
      busqueda: "",
      mostrarFormulario: false,
      mostrarModal: false,
      mostrarModalEliminar: false,
      nuevoGrupo: {
        NombreGrupo: "",
        MinSelecciones: 0,
        MaxSelecciones: 1,
        Incluidas: 0,
         AreaProduccion: 1,
        items: [{ IdOpcion: "", PrecioExtra: 0 }]
      },
      grupoEditar: null,
      grupoEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" }
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerGrupos() {
      const { data } = await axios.get(`${API_URL}/grupos-opciones`);
      this.grupos = data.data || data;
      this.copiaLista = [...this.grupos];
    },
    async obtenerOpciones() {
      const { data } = await axios.get(`${API_URL}/opciones-comida`);
      this.opciones = data.data|| data;
    },
    agregarItem() {
      this.nuevoGrupo.items.push({ IdOpcion: "", PrecioExtra: 0 });
    },
    eliminarItem(index) {
      this.nuevoGrupo.items.splice(index, 1);
    },
    async guardarGrupo() {
      try {
        const { data } = await axios.post(`${API_URL}/grupos-opciones`, this.nuevoGrupo);
        this.mostrarAlerta(data.message || "Grupo creado con éxito");
        this.nuevoGrupo = { NombreGrupo: "", MinSelecciones: 0, MaxSelecciones: 1, Incluidas: 0, items: [{ IdOpcion: "", PrecioExtra: 0 }] };
        this.mostrarFormulario = false;
        this.obtenerGrupos();
      } catch (error) {
        this.mostrarAlerta(error.response?.data?.message || "Error al guardar", "danger");
      }
    },
    abrirModal(grp) {
      this.grupoEditar = JSON.parse(JSON.stringify(grp));
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.grupoEditar = null;
      this.mostrarModal = false;
    },
    async actualizarGrupo() {
      try {
        const payload = {
          NombreGrupo: this.grupoEditar.NombreGrupo,
          MinSelecciones: this.grupoEditar.MinSelecciones,
          MaxSelecciones: this.grupoEditar.MaxSelecciones,
          Incluidas: this.grupoEditar.Incluidas,
          AreaProduccion: this.grupoEditar.AreaProduccion,
          items: this.grupoEditar.items.map(i => ({
            IdOpcion: i.IdOpcion,
            PrecioExtra: i.PrecioExtra
          }))
        };

        const { data } = await axios.put(`${API_URL}/grupos-opciones/${this.grupoEditar.IdGrupoOpcion}`, payload);
        this.mostrarAlerta(data.message || "Grupo actualizado");
        this.cerrarModal();
        this.obtenerGrupos();
      } catch (error) {
        this.mostrarAlerta(error.response?.data?.message || "Error al actualizar", "danger");
      }
    },
    abrirModalEliminar(grp) {
      this.grupoEliminar = { ...grp };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.grupoEliminar = null;
      this.mostrarModalEliminar = false;
    },
    async confirmarEliminar() {
      try {
        const { data } = await axios.delete(`${API_URL}/grupos-opciones/${this.grupoEliminar.IdGrupoOpcion}`);
        this.mostrarAlerta(data.message || "Grupo eliminado");
        this.obtenerGrupos();
      } catch (error) {
        this.mostrarAlerta(error.response?.data?.message || "Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    buscarGrupo() {
      const q = (this.busqueda || "").trim().toLowerCase();
      if (!q) {
        this.grupos = [...this.copiaLista];
        return;
      }
      this.grupos = this.copiaLista.filter(grp => (grp.NombreGrupo || "").toLowerCase().includes(q));
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevoGrupo = { NombreGrupo: "", MinSelecciones: 0, MaxSelecciones: 1, Incluidas: 0,AreaProduccion: 1, items: [{ IdOpcion: "", PrecioExtra: 0 }] };
    }
  },
  mounted() {
    this.obtenerGrupos();
    this.obtenerOpciones();
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
}
.modal-content {
  background: #fff;
  width: 650px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  z-index: 5001;
}
</style>
